

var RecaptchaResource = function() {
  var self = this;
  var callback;

  self.enabled = true;

  self.onSubmit = function(token) {
    if (typeof callback === 'function') {
      callback(token);
    }
  };

  self.execute = function(cb) {
    callback = cb;
    if (!self.enabled) {
      callback();
      return
    }
     
    grecaptcha.execute();
  };

  self.reset = function() {
    if (self.enabled) {
      grecaptcha.reset();
    }
  }
};

window.recaptchaResource = new RecaptchaResource();

var onRecaptchaToken = function(token) {
  recaptchaResource.onSubmit(token);
}

$(function() {
  recaptchaResource.enabled = $('.g-recaptcha').length > 0;
});